import { render, staticRenderFns } from "./OcrRecognize.vue?vue&type=template&id=98d8ec1c&scoped=true"
import script from "./OcrRecognize.vue?vue&type=script&lang=js"
export * from "./OcrRecognize.vue?vue&type=script&lang=js"
import style0 from "./OcrRecognize.vue?vue&type=style&index=0&id=98d8ec1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d8ec1c",
  null
  
)

export default component.exports